import { render, staticRenderFns } from "./ClienteDadosMaioresCrescimento.vue?vue&type=template&id=24588d9a&scoped=true&"
import script from "./ClienteDadosMaioresCrescimento.vue?vue&type=script&lang=js&"
export * from "./ClienteDadosMaioresCrescimento.vue?vue&type=script&lang=js&"
import style0 from "./ClienteDadosMaioresCrescimento.vue?vue&type=style&index=0&id=24588d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24588d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
